import { render, staticRenderFns } from "./BlackIpView.vue?vue&type=template&id=d7ffb358&"
import script from "./BlackIpView.vue?vue&type=script&lang=js&"
export * from "./BlackIpView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports